import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { DropTarget } from 'react-dnd';
import { createTask, updateTask, deleteTask } from '~/Redux/Modules/Tasks';
import { DATE_FORMAT } from '~/Redux/Constants';
import QuillInput from '~/Components/Quill/QuillInput';
import { DAY_CHECKLIST } from '~/Config/DragTypes';
import Store from '~/Redux/Store';
import { TYPES } from '~/Config/Checklists';
import { nextPriority } from './helpers';

const taskTarget = {
  canDrop: () => true,
  drop: ({ type, date, prevTask }, monitor) => {
    const { task } = monitor.getItem();
    if (task.type !== type) {
      Store.dispatch(
        deleteTask({
          ...task,
          recurrence_id: task.recurrence_id || task.start,
          confirm: 'this',
        })
      );
      Store.dispatch(
        createTask({
          ...task,
          type,
          repeat_rule: null,
          start: date.format(DATE_FORMAT),
          priority: nextPriority(prevTask?.priority),
          confirm: 'this',
        })
      );
    } else {
      Store.dispatch(
        updateTask({
          ...task,
          type,
          repeat_rule: null,
          start: date.format(DATE_FORMAT),
          priority: nextPriority(prevTask?.priority),
          recurrence_id: task.recurrence_id || task.start,
          confirm: 'this',
        })
      );
    }
  },
};

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  dragItem: monitor.getItem(),
  monitor: monitor,
});

const NewTask = ({
  date,
  type,
  isOver,
  connectDropTarget,
  setNewItemRef,
  prevTask,
  disableTaskWrapping,
}) => {
  const createId = `create-${type}-${date.format(DATE_FORMAT)}`;
  const [newItemSummary, setNewItemSummary] = useState('');
  const dispatch = useDispatch();

  const createNewItem = (summary, lastPriority) => {
    if (!summary) return;
    const newTask = {
      type,
      start: date.format(DATE_FORMAT),
      summary,
      priority: nextPriority(lastPriority || prevTask?.priority),
    };
    dispatch(createTask(newTask));
    setNewItemSummary('');
    return newTask.priority;
  };

  const handleNewSummary = newSummary => {
    const items = newSummary.split('\n');
    if (items.length > 1) {
      newSummary = items.last;
      items.slice(0, items.length - 1).reduce((a, item) => createNewItem(item, a), null);
    }
    setNewItemSummary(newSummary);
  };

  return connectDropTarget(
    <div
      className={`create-task flex-row ${isOver ? 'is-over' : ''} ${
        disableTaskWrapping ? 'disable-task-wrapping' : ''
      }`}
    >
      <div className="flex-1">
        <QuillInput
          id={createId}
          name="summary"
          value={newItemSummary}
          onChange={({ summary }) => handleNewSummary(summary)}
          onEnter={() => createNewItem(newItemSummary)}
          onBlur={() => createNewItem(newItemSummary)}
          ref={r => setNewItemRef(r)}
        />
      </div>
    </div>
  );
};

NewTask.propTypes = {
  date: PropTypes.object.isRequired,
  type: PropTypes.oneOf(TYPES),
  prevTask: PropTypes.shape({
    priority: PropTypes.string,
  }),
  isOver: PropTypes.bool,
  connectDropTarget: PropTypes.func.isRequired,
  setNewItemRef: PropTypes.func.isRequired,
  disableTaskWrapping: PropTypes.bool,
};

export default NewTask |> DropTarget(DAY_CHECKLIST, taskTarget, dropCollect);
